import { Typography } from "antd";
import { type ReactNode, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import "./Page.scss";

interface Props {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  showBackButton?: boolean;
  backButtonTextKey?: string;
  onBack?: () => void;
  tabTitle?: string;
}

const Page = ({
  children,
  title,
  subtitle,
  showBackButton = true,
  backButtonTextKey = "goback",
  onBack,
  tabTitle = "Competition Management",
}: Props) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  }, [onBack, navigate]);

  return (
    <div>
      {showBackButton && (
        <div className="back-button-wrapper">
          <i className="fas fa-arrow-left" />
          <span onClick={handleBack}>
            {formatMessage({ id: backButtonTextKey })}
          </span>
        </div>
      )}
      <Helmet>
        <title>{tabTitle}</title>
      </Helmet>
      <div className="page-title-wrapper">
        {title && <Typography.Title level={2}>{title}</Typography.Title>}
        {subtitle && <Typography.Text>{subtitle}</Typography.Text>}
      </div>
      {children}
    </div>
  );
};

export default Page;
